import Language from './enums/Language'
import DayKey from './types/DayKey'

// FIXME: Refactor to enum.
export const THEMES = {
  DEFAULT: 'default',
  DARK: 'dark',
  LIGHT: 'light',
  BLUE: 'blue',
  GREEN: 'green',
  INDIGO: 'indigo'
}

export const DEFAULT_THEME = THEMES.DARK

export const DEFAULT_LANGUAGE = Language.ENGLISH_US

export const DAYS_OF_THE_WEEK: DayKey[] = [1, 2, 3, 4, 5, 6, 0] as const

export const DEFAULT_TIMEZONE = 'Europe/Helsinki' as const
